import Autocomplete, { AutocompleteProps } from "@mui/material/Autocomplete";

export type { AutocompleteProps };
export default Autocomplete;
